"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_85_2_1 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * map SpecificArticles.ketteSystemKuerzel to SpecificArticles.ketteEchainSystem
 * remove SpecificArticles.ketteSystemKuerzel
 */
const migration_85_2_1 = (json) => {
    if (json.SpecificArticles) {
        if (json.SpecificArticles.ketteSystemKuerzel) {
            if (json.SpecificArticles.ketteSystemKuerzel.length === 0) {
                json.SpecificArticles.ketteEchainSystem = [];
            }
            else {
                json.SpecificArticles.ketteEchainSystem = Array.from(new Set(json.SpecificArticles.ketteSystemKuerzel
                    .map((kurzel) => (0, echain_shared_articles_1.echainSystemFromIproSystemRefKuerzel)(kurzel))
                    .filter((k) => Boolean(k))));
            }
            delete json.SpecificArticles.ketteSystemKuerzel;
        }
        if (!json.SpecificArticles.ketteEchainSystem) {
            json.SpecificArticles.ketteEchainSystem = [];
        }
    }
    return json;
};
exports.migration_85_2_1 = migration_85_2_1;
//# sourceMappingURL=migration_85_2_1.js.map